import * as o from "react";
const t = /* @__PURE__ */ o.createContext(void 0);
process.env.NODE_ENV !== "production" && (t.displayName = "FormControlContext");
const n = t;
function e() {
  return o.useContext(n);
}
export {
  e as u
};
